import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Sidebar from "../../layout/Sidebar";
import Navbar from "../../layout/Navbar";
import { getspecificSingleProduct } from "../../../actions/singleProductAction";
import PicturesWall from "./PictureWall";
import ShowImage from "./ShowImage";
import { getspecificproductvariationForImage } from "../../../actions/variableProductAction";
import { updateproductdetails } from "../../../actions/singleProductAction";
import { reorderProductImages } from "../../../actions/productDetails";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  Divider,
  Button,
  Affix,
  Skeleton,
  Form,
  Checkbox,
  Spin,
  message
} from "antd";
import { RightOutlined } from "@ant-design/icons";
const { Content } = Layout;

const ViewProductDetails = ({
  getspecificSingleProduct,
  details,
  getspecificproductvariationForImage,
  updateproductdetails,
  reorderProductImages,
  Variations,
  auth,
}) => {
  const { id } = useParams();
  const [newimage, setnewimage] = useState(false);
  const [loading, setloading] = useState(true);
  const [saving, setSaving] = useState(false);
  const colors = new Set();
  const color_ids = new Set();
  const variations = useRef();
  const variations_id = useRef();
  const [form] = Form.useForm();

  const sensors = useSensors(
    useSensor(MouseSensor, {
      // Require the mouse to move by 5px before activating drag
      // This allows normal clicks (e.g. Remove button) to work
      activationConstraint: { distance: 5 },
    }),
    useSensor(TouchSensor, {
      // Delay of 250ms + 5px tolerance for touch devices / Safari on iOS
      activationConstraint: { delay: 250, tolerance: 5 },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  useEffect(() => {
    getspecificproductvariationForImage(id).then((r) => {
      for (let i = 0; i < r.length; i++) {
        if (typeof r[i].color != "undefined") {
          colors.add(r[i].color);
          color_ids.add(r[i].Color);
        }
      }
      variations.current = Array.from(colors);
      variations_id.current = Array.from(color_ids);
      getspecificSingleProduct(id).then((e) => {
        setloading(false);

        // setnewimage(false);
      });
    });
  }, [newimage]);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over) return;

    if (active.id !== over.id) {
      const oldIndex = details.image.findIndex((img) => img.id.toString() === active.id.toString());
      const newIndex = details.image.findIndex((img) => img.id.toString() === over.id.toString());

      const newOrderedImages = arrayMove(details.image, oldIndex, newIndex);

      const reorderData = newOrderedImages.map((img, index) => ({
        id: img.id,
        order: index,
      }));

      setSaving(true);
      reorderProductImages(reorderData).then(() => {
        setnewimage(!newimage);
        setSaving(false);
        message.success("Image order saved!");
      }).catch(() => {
        setSaving(false);
        message.error("Failed to save order. Please try again.");
      });
    }
  };

  const onFinish = (values) => {
    updateproductdetails(details.id, values).then((result) => {
      message.success("Successfully updated");

    });
  }

  if (loading) {
    return <Skeleton active />;
  } else {
    const coverImages = details.image.filter((img) => img.Color == null);
    const extraImages = details.image.filter((img) => img.Color != null && !variations_id.current.includes(img.Color));

    return (
      <Spin spinning={saving} tip="Saving order..." size="large">
        <Layout className="window-frame">
          <Sidebar />
          <Layout className="site-layout">
            <Navbar />
            <Content className="main-frame-content">
              <Breadcrumb style={{ margin: "16px 0" }}>
                <Breadcrumb.Item>Products</Breadcrumb.Item>
                <Breadcrumb.Item>{details.title}</Breadcrumb.Item>
                <Breadcrumb.Item>Images</Breadcrumb.Item>
              </Breadcrumb>
              <div className="site-layout-background main-frame">

                <DndContext 
                  sensors={sensors}
                  collisionDetection={closestCenter}
                  onDragEnd={handleDragEnd}
                >
                  <h3>Cover Photo</h3>
                  <Row>
                    <Col span={4} style={{ borderRight: "1px solid lightgray" }}>
                      <PicturesWall
                        limit={6}
                        porductid={id}
                        variationid={null}
                        Color={null}
                        cover={null}
                        setnewimage={setnewimage}
                        newimage={newimage}
                      />
                    </Col>
                    <Col span={16}>
                      <SortableContext 
                        items={coverImages.map(img => img.id.toString())}
                        strategy={rectSortingStrategy}
                      >
                        <Row>
                          {coverImages.map((detail) => (
                            <ShowImage
                              key={detail.id}
                              details={detail}
                              setnewimage={setnewimage}
                              newimage={newimage}
                            />
                          ))}
                        </Row>
                      </SortableContext>
                    </Col>
                    <Col span={4}>
                      <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        initialValues={details}
                      >
                        <Form.Item name="is_sellable" valuePropName="checked">
                          <Checkbox >Sellable Product !</Checkbox>
                        </Form.Item>
                        <Form.Item>
                          <Button type="success" style={{ backgroundColor: "green", borderColor: "green", color: "white" }} htmlType="submit">
                            Submit
                          </Button>
                        </Form.Item>
                      </Form>
                    </Col>
                  </Row>

                  <Divider />

                  {variations.current.map((variation, index) => {
                    const groupImages = details.image.filter(img => img.Color === variations_id.current[index]);
                    return (
                      <div key={variations_id.current[index]}>
                        <h3>{variation}</h3>
                        <Row>
                          <Col
                            span={4}
                            style={{ borderRight: "1px solid lightgray" }}
                          >
                            <PicturesWall
                              limit={6}
                              porductid={id}
                              variationid={null}
                              Color={variations_id.current[index]}
                              cover={null}
                              setnewimage={setnewimage}
                              newimage={newimage}
                            />
                          </Col>
                          <Col span={20}>
                            <SortableContext 
                              items={groupImages.map(img => img.id.toString())}
                              strategy={rectSortingStrategy}
                            >
                              <Row>
                                {groupImages.map((detail) => (
                                  <ShowImage
                                    key={detail.id}
                                    details={detail}
                                    setnewimage={setnewimage}
                                    newimage={newimage}
                                  />
                                ))}
                              </Row>
                            </SortableContext>
                          </Col>
                        </Row>
                        <Divider />
                      </div>
                    );
                  })}
                  <Divider />
                  <h3>Extra/misplaced Images</h3>
                  <Row>
                    <Col span={24}>
                      <SortableContext 
                        items={extraImages.map(img => img.id.toString())}
                        strategy={rectSortingStrategy}
                      >
                        <Row>
                          {extraImages.map((detail) => (
                            <ShowImage
                              key={detail.id}
                              details={detail}
                              setnewimage={setnewimage}
                              newimage={newimage}
                            />
                          ))}
                        </Row>
                      </SortableContext>
                    </Col>
                  </Row>
                </DndContext>
              </div>
            </Content>
          </Layout>
        </Layout>
      </Spin>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    details: state.singleProduct.singleproduct,
    Variations: state.ProductDetails.productdetails,
  };
};

export default connect(mapStateToProps, {
  getspecificSingleProduct,
  getspecificproductvariationForImage,
  updateproductdetails,
  reorderProductImages,
})(ViewProductDetails);
